cockpitApp.directive('menuRight', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/menu/right',
    controllerAs: 'menuRightCtrl',
    controller: 'menuRightController'
  };
});
